export const RECEIVE_SEED = 'RECEIVE_SEED';

export const receiveSeed = (seed) => ({
    type: RECEIVE_SEED,
    seed
});

export const generateNewSeed = () => (dispatch) => {
    return dispatch(receiveSeed(Math.random()));
};